/* import { useState } from "react";
import { AuthAPI } from "../api/apiClient";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

export default function RegisterPage() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleRegister = async () => {
    try {
      const result = await AuthAPI.register(userName, password, email);

      if (result.user) {
        localStorage.setItem("user", JSON.stringify(result.user));
      }

      toast.success("Account created!");
      navigate("/");
    } catch (err: any) {
      toast.error(err.message ?? "Registration failed");
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100 px-4">
      <div className="bg-white p-6 shadow rounded w-full max-w-sm space-y-4">
        <h2 className="text-xl font-semibold">Create Account</h2>

        <input
          placeholder="Username"
          className="border p-2 w-full rounded"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
        />

        <input
          placeholder="Email (optional)"
          className="border p-2 w-full rounded"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          className="border p-2 w-full rounded"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          onClick={handleRegister}
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
        >
          Register
        </button>

        <button
          onClick={() => navigate("/login")}
          className="text-sm text-gray-600 hover:underline w-full text-center"
        >
          Already have an account? Login
        </button>
      </div>
    </div>
  );
} */

  import { useState } from "react";
import { AuthAPI } from "../api/apiClient";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

export default function RegisterPage() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");

  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);

  const [loading, setLoading] = useState(false);

  const [otpError, setOtpError] = useState("");
  const [otpSuccess, setOtpSuccess] = useState("");

  const navigate = useNavigate();

  // Register
  const handleRegister = async () => {
    setOtpError("");
    setOtpSuccess("");

    if (!userName || !email || !password) {
      toast.error("Please fill all fields.");
      return;
    }

    try {
      setLoading(true);

      await AuthAPI.register(userName, password, email);

      toast.success("OTP has been sent to your email.");

      setShowOtp(true);
    } catch (err: any) {
      toast.error(err.message ?? "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  // Verify OTP
  const handleVerifyOtp = async () => {
    setOtpError("");
    setOtpSuccess("");

    if (!otp.trim()) {
      setOtpError("Please enter OTP.");
      return;
    }

    try {
      const result = await AuthAPI.verifyEmailOtp(email, otp);

     /*  setOtpSuccess(
        result.message ??
          "✓ OTP verified successfully.\n✓ Registration completed successfully."
      ); */
      setOtpSuccess(
  "✓ OTP verified successfully.\n✓ Registration completed successfully."
);

      toast.success("Registration completed successfully.");

      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err: any) {
      setOtpError(err.message ?? "Invalid OTP");
    }
  };

  // Resend OTP
  const handleResendOtp = async () => {
  setOtpError("");
  setOtpSuccess("");

  try {
    await AuthAPI.resendEmailOtp(email);

    // Show success message below the OTP textbox
    setOtpSuccess("✓ New OTP sent successfully.");

    // Optional toast
    toast.success("New OTP sent successfully.");
  } catch (err: any) {
    setOtpError(err.message ?? "Failed to resend OTP");

    // Optional toast
    toast.error(err.message ?? "Failed to resend OTP");
  }
};
    return (
    <div className="flex items-center justify-center h-screen bg-gray-100 px-4">
      <div className="bg-white p-6 shadow rounded w-full max-w-sm space-y-4">
        <h2 className="text-xl font-semibold text-center">
          Create Account
        </h2>

        {!showOtp ? (
          <>
            <input
              placeholder="Username"
              className="border p-2 w-full rounded"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />

            <input
              type="email"
              placeholder="Email"
              className="border p-2 w-full rounded"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              type="password"
              placeholder="Password"
              className="border p-2 w-full rounded"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button
              onClick={handleRegister}
              disabled={loading}
              className={`w-full py-2 rounded text-white ${
                loading
                  ? "bg-blue-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              {loading ? "Sending OTP..." : "Register"}
            </button>
          </>
        ) : (
          <>
            <div className="text-center text-sm text-gray-600">
              An OTP has been sent to
              <br />
              <span className="font-semibold">{email}</span>
            </div>

            <input
              placeholder="Enter OTP"
              className="border p-2 w-full rounded"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            {/* Success Message */}
            {otpSuccess && (
              <div className="bg-green-100 border border-green-400 text-green-700 px-3 py-2 rounded text-sm whitespace-pre-line">
                {otpSuccess}
              </div>
            )}

            {/* Error Message */}
            {otpError && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-3 py-2 rounded text-sm">
                {otpError}
              </div>
            )}

            <button
              onClick={handleVerifyOtp}
              className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700"
            >
              Verify OTP
            </button>

            <button
              onClick={handleResendOtp}
              className="w-full border border-blue-600 text-blue-600 py-2 rounded hover:bg-blue-50"
            >
              Resend OTP
            </button>

            <button
              onClick={() => {
                setOtp("");
                setOtpError("");
                setOtpSuccess("");
                setShowOtp(false);
              }}
              className="w-full text-sm text-gray-500 hover:underline"
            >
              Back
            </button>
          </>
        )}

        <button
          onClick={() => navigate("/login")}
          className="text-sm text-gray-600 hover:underline w-full text-center"
        >
          Already have an account? Login
        </button>
      </div>
    </div>
  );
}